const European = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 24 24' fill='none'>
			<g clipPath='url(#clip0_479_13733)'>
				<path
					d='M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z'
					fill='#0052B4'
				/>
				<path
					d='M12 4.69556L12.3886 5.89129H13.6458L12.6286 6.63028L13.0172 7.82601L12 7.08698L10.9828 7.82601L11.3714 6.63028L10.3542 5.89129H11.6115L12 4.69556Z'
					fill='#FFDA44'
				/>
				<path
					d='M6.83499 6.83503L7.9553 7.40578L8.84428 6.51685L8.64755 7.75856L9.76781 8.32936L8.52605 8.52605L8.32936 9.76786L7.75856 8.6476L6.51685 8.84433L7.40583 7.95535L6.83499 6.83503Z'
					fill='#FFDA44'
				/>
				<path
					d='M4.69568 11.9998L5.89141 11.6112V10.354L6.63035 11.3712L7.82613 10.9826L7.08705 11.9998L7.82613 13.0169L6.63035 12.6284L5.89141 13.6456V12.3883L4.69568 11.9998Z'
					fill='#FFDA44'
				/>
				<path
					d='M6.83499 17.165L7.40578 16.0446L6.51685 15.1557L7.75861 15.3524L8.32931 14.2322L8.52605 15.4739L9.76777 15.6706L8.64764 16.2414L8.84428 17.4831L7.9553 16.5942L6.83499 17.165Z'
					fill='#FFDA44'
				/>
				<path
					d='M12 19.3042L11.6114 18.1085H10.3542L11.3714 17.3695L10.9828 16.1738L12 16.9128L13.0172 16.1738L12.6286 17.3695L13.6458 18.1085H12.3885L12 19.3042Z'
					fill='#FFDA44'
				/>
				<path
					d='M17.165 17.165L16.0447 16.5942L15.1557 17.4832L15.3524 16.2414L14.2322 15.6706L15.474 15.4739L15.6706 14.2322L16.2414 15.3524L17.4831 15.1557L16.5941 16.0447L17.165 17.165Z'
					fill='#FFDA44'
				/>
				<path
					d='M19.3043 11.9998L18.1086 12.3883V13.6456L17.3696 12.6284L16.174 13.0169L16.9129 11.9998L16.174 10.9826L17.3696 11.3712L18.1086 10.354V11.6113L19.3043 11.9998Z'
					fill='#FFDA44'
				/>
				<path
					d='M17.165 6.83499L16.5942 7.9553L17.4832 8.84428L16.2413 8.6475L15.6706 9.76777L15.474 8.526L14.2322 8.32927L15.3524 7.75852L15.1557 6.51685L16.0448 7.40578L17.165 6.83499Z'
					fill='#FFDA44'
				/>
			</g>
			<defs>
				<clipPath id='clip0_479_13733'>
					<rect width='24' height='24' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};

export default European;
